<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		},
		created() {

		}
	}
</script>


<style lang="scss">
	@import "./assets/css/h5.scss";
	@import "./assets/css/pc.scss";
	@import "./assets/css/transition.css";
	.el-message__icon{
		font-size: 20px;
	}
	.el-drawer {
		background-color: rgba(0, 0, 0, 0) !important;
		z-index: 999;
	}

	.el-loading-spinner {
		.el-icon-loading {
			font-size: 25px;
			color: #256C43;
		}

		.el-loading-text {
			font-size: 25px;
			color: #256C43 !important;
		}
	}

	.u-flex {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.u-flex-col {
		display: flex;
		flex-direction: column;
	}

	.u-flex-wrap {
		flex-wrap: wrap;
	}

	.u-flex-nowrap {
		flex-wrap: nowrap;
	}

	.u-col-center {
		align-items: center;
	}

	.u-col-top {
		align-items: flex-start;
	}

	.u-col-bottom {
		align-items: flex-end;
	}

	.u-row-center {
		justify-content: center;
	}

	.u-row-left {
		justify-content: flex-start;
	}

	.u-row-right {
		justify-content: flex-end;
	}

	.u-row-between {
		justify-content: space-between;
	}

	.u-row-around {
		justify-content: space-around;
	}
	.text_hide3{
		
		/* overflow: hidden;				
		text-overflow: ellipsis;		
		display: -webkit-box;			
		-webkit-line-clamp: 3;
		line-clamp: 3;	
		-webkit-box-orient: vertical; 
		box-orient: vertical; */

		display: -webkit-box;
		-webkit-line-clamp: 3; /* 设置显示的行数 */

		/* autoprefixer: ignore next */
		-webkit-box-orient: vertical;

		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
